import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=373491fc&scoped=true"
import script from "./ProductIntro.vue?vue&type=script&lang=js"
export * from "./ProductIntro.vue?vue&type=script&lang=js"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=373491fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373491fc",
  null
  
)

export default component.exports